class MoreInfoPanel extends HTMLElement {
  constructor() {
    super();
    this.productHandle = '';

    this.closeOverlayHandler = this.close.bind(this);
    this.closeButtonHandler = this.close.bind(this);
    this.escapeKeyHandler = this.handleEscape.bind(this);

  }

  updateProperties(props = {}) {
    //console.log('updateProperties', props);
    Object.assign(this, props);
  }

  async loadMainProduct() {
    if (!this.productHandle) throw new Error('No productHandle set');
    const sectionId = 'pdp-more-info';
    const url = `/products/${this.productHandle}?view=welcome-2025&section_id=${sectionId}`;
    console.log('url', url);
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to load section: ${res.status}`);
    const html = await res.text();

    // you need a container inside your panel to receive this HTML
    const container = this.querySelector('.more-info-content');
    if (!container) {
      console.warn('No .more-info-content element found');
      return;
    }
    console.log('this.productHandle', this.productHandle);
    container.innerHTML = html;
    this.resetScroll();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    // overlay click to close
    this.overlay = this.querySelector('.panel-overlay');
    this.overlay?.addEventListener('click', this.closeOverlayHandler);

    // close button click
    this.closeButton = this.querySelector('.drawer_close');
    this.closeButton?.addEventListener('click', this.closeButtonHandler);
  }

  removeEventListeners() {
    this.overlay?.removeEventListener('click', this.closeOverlayHandler);
    this.closeButton?.removeEventListener('click', this.closeButtonHandler);
    document.removeEventListener('keydown', this.escapeKeyHandler, true);
  }

  handleEscape(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.close();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  addClubToCart() {
    window.__abc.addClubMembershipToCart();
    this.close();
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    // trap focus inside the panel
    const container = this.querySelector('.drawer__inner');
    const fallbackFocus = this.querySelector('.drawer_close');
    if (typeof trapFocus === 'function' && container) {
      trapFocus(container, fallbackFocus);
    }
    this.resetScroll();
    document.addEventListener('keydown', this.escapeKeyHandler, true);
  }

  close() {
    this.classList.remove('active');
    document.removeEventListener('keydown', this.escapeKeyHandler, true);

    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');

    // return focus to the triggering element
    if (this.activeElement) {
      this.activeElement.focus();
    }
  }

  setActiveElement(el) {
    this.activeElement = el;
  }

  resetScroll() {
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.scrollTop = 0;
  }
}

customElements.define('more-info-panel', MoreInfoPanel);

document.addEventListener('DOMContentLoaded', () => {
  // Existing welcome offer launcher
  document.querySelectorAll('.launch_welcome_offer').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const panel = document.querySelector('welcome-offer-panel');
      if (panel) panel.open(link);
    });
  });
  // New more info buttons
  document.querySelectorAll('.product_more_info_btn').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      const handle = btn.dataset.handle;
      if (!handle) {
        console.warn('Missing data-handle on product_more_info_btn');
        return;
      }

      const panel = document.querySelector('more-info-panel');
      if (!panel) return;

      panel.updateProperties({ productHandle: handle });

      panel
        .loadMainProduct()
        .then(() => {
          panel.open(btn);
        })
        .catch((err) => {
          console.error('Error loading product info:', err);
        });
    });
  });
});

/*
  handleMoreInfoClick(event) {
    event.preventDefault();
    console.log(`More info about product: ${this.product.title}`, this.product);
    const moreInfoPanel = document.querySelector('more-info-panel');
    if (!moreInfoPanel) return;
    moreInfoPanel.updateProperties({
      productHandle: this.product.handle,
    });

    moreInfoPanel
      .loadMainProduct()
      .then(() => {
        moreInfoPanel.open(this);
      })
      .catch((err) => {
        console.error('Error loading product info:', err);
      });
  }
      */
